﻿﻿﻿<!--<elevator-menu (outputDownload)="downloadElevatorFiltered()" (onReload)="onReload()"></elevator-menu>-->
<facilitymanager-filter (outputFilter)="getFilteredItemsByTenant()"></facilitymanager-filter>
<facilitymanager-list [list]="list" [showLocalFilter]="showLocalFilter"></facilitymanager-list>